import { z } from 'zod';

export const ResourceUpdatedEventSchema = z.object({
  type: z.literal('resource_updated'),
  data: z.object({
    resourceType: z.enum([
      'conversation',
      'agent_run',
      'task',
      'agent_execution',
      'pipeline_execution',
    ]),
    resourceId: z.string(),
  }),
});

export const ConversationMessageStreamUpdatedEventSchema = z.object({
  type: z.literal('conversation_message_stream_updated'),
  data: z.object({
    conversationId: z.string(),
    conversationMessageId: z.string(),
    message: z.string(),
    thoughts: z.array(
      z.object({
        text: z.string(),
        createdAt: z.string(),
      }),
    ),
  }),
});

export const EventbusEventSchema = z.discriminatedUnion('type', [
  // Published when new messages are created within a conversation
  // NOTE: this is used as a convenience to alert frontend for a variety of different resources, try to use this instead of changing a lot of other things....
  ResourceUpdatedEventSchema,
  // Published when a new message is being streamed to the frontend prior to the message being finalized
  // NOTE: this provides the full message and not just the new chunk, this will *maybe* be optimized later to stream chunks, just more complicated
  ConversationMessageStreamUpdatedEventSchema,
]);

export type EventbusEvent = z.infer<typeof EventbusEventSchema>;
